import * as React from 'react';
import Restricted from '../permissions/Restricted';
import Dropdown from '../../components_v2/dropdown/Dropdown';
import { SelectionAction } from './style/Style';
import { translateToString } from '../../styles/global/translate';
import { BuildingComplex, Calendar, Pencil, Trash2, X } from 'lucide-react';
import { getImageFromEventTypeName } from './Companies';
import { BorderColor, OnPrimaryColor, PastelPrimaryColor, PrimaryColor, RedSidely, SurfaceColor } from '../../styles/global/css/Utils';
import { AEventTypes, AtomEventType } from '../../atoms/global/events';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

export const BottomActionButtonsWrapperWrapper = styled.div`
	position: absolute;
	bottom: 30px;
  	left: 50%;
   	translate: -50%;
    display: flex;
    gap: 10px;
    z-index: 9;
`;

export const BottomActionButtonsWrapper = styled(SelectionAction) <{ round?: boolean }>`
	display: flex;
	gap: 5px;
	align-items: center;
	border-radius: 9999px;
	cursor: pointer;
	border: 1px solid ${BorderColor};
	background-color: ${SurfaceColor};
    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.12);
    ${p => p.round ? `
    	flex-shrink: 0;
   		width: 40px;
     	height: 40px;
      	justify-content: center;
       	padding: 0;
    ` : `
     	padding: 5px 15px 5px 10px;
    `}
    &:hover {
        background-color: ${PastelPrimaryColor};
    }
`;

export const NumberContainer = styled.div`
	background:  ${PrimaryColor};
	color: ${OnPrimaryColor};
	border-radius: 999px;
	padding: 1px 7px;
`;


export default function BottomActionButtons(props: {
	createEvents: (type: AtomEventType) => void,
	enrich?: () => void,
	edit: () => void,
	delete: () => void,
	selectAll: () => void,
	isAllSelected: boolean,
	selectedRows: number,
	maxSelectedRows: number,
	removeSelection: () => void,
}) {
	const eventTypes = useRecoilValue(AEventTypes);
	return <BottomActionButtonsWrapperWrapper>
		<BottomActionButtonsWrapper round onClick={props.removeSelection} titleHover={translateToString('clear_selection')}>
			<X />
		</BottomActionButtonsWrapper>
		<BottomActionButtonsWrapper
			onClick={props.isAllSelected ? undefined : props.selectAll}
			titleHover={props.isAllSelected ? undefined : translateToString('select_all_{{NUMBER}}_records', [['NUMBER', props.maxSelectedRows.toString()]])}
		>
			<NumberContainer>
				{props.isAllSelected ? props.maxSelectedRows : props.selectedRows}
			</NumberContainer>
			<p style={{ margin: 0, textOverflow: 'ellipsis', overflow: 'hidden', fontWeight: 600 }}>
				{translateToString('selected')}
			</p>
		</BottomActionButtonsWrapper>
		<Restricted to={{ objectAction: 'CreateEvent' }}>
			<Dropdown
				autoOptionUp
				dropdownStyle={{
					height: 'fit-content',
					containerHeight: 'fit-content',
					optionWidth: '220px',
					optionHeight: '260px',
					containerTop: '30px',
				}}
				JSXButton={({ setIsOpen }) =>
					<BottomActionButtonsWrapper round titleHover={translateToString('map.modal_right.create_events')} onClick={() => setIsOpen(t => !t)}>
						<Calendar />
					</BottomActionButtonsWrapper>}

				datalist={eventTypes.map(et => ({
					value: et,
					label: translateToString('map.modal_right.create') + ' ' + translateToString(`event.${et.name}`),
					imageJsx: getImageFromEventTypeName(et.name)
				}))}
				name={'event_type_dropdown'}
				onChange={(value) => props.createEvents(value.value)}
			/>
		</Restricted>
		<Restricted to={{ objectAction: 'UpdateCompany' }}>
			{props.enrich && <BottomActionButtonsWrapper round titleHover={translateToString('enrich_geo_positions')} onClick={props.enrich}>
				<BuildingComplex />
			</BottomActionButtonsWrapper>}
			<BottomActionButtonsWrapper round titleHover={translateToString('edit_selection')} onClick={props.edit}>
				<Pencil />
			</BottomActionButtonsWrapper>
		</Restricted>
		<Restricted to={{ objectAction: 'DeleteCompany' }}>
			<BottomActionButtonsWrapper round titleHover={translateToString('delete_selection')} onClick={props.delete}>
				<Trash2 color={RedSidely} />
			</BottomActionButtonsWrapper>
		</Restricted>
	</BottomActionButtonsWrapperWrapper>;
}
